import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';

export const useSetQueryParam = () => {
  const history = useHistory();

  const setQueryParams = useCallback(
    (updates: Record<string, string | undefined | null>, isReplace = false) => {
      const newQuery = new URLSearchParams(window.location.search);

      Object.entries(updates).forEach(([key, value]) => {
        if (value === null || value === undefined) {
          newQuery.delete(key);
        } else {
          newQuery.set(key, value);
        }
      });

      const params = {
        pathname: location.pathname,
        search: newQuery.toString()
      };

      if (isReplace) {
        history.replace(params);
      } else {
        history.push(params);
      }
    },
    [history]
  );

  return setQueryParams;
};
